module.exports = __webpack_public_path__ + "img/Nora-logoFooter_dark.e1d07b.png";